export default __webpack_public_path__ + "static/media/ratingsIcon.152915f8.svg";